import {Pipe, PipeTransform} from '@angular/core';
import {AuthorisationService} from '../services/auth/authorisation.service';
import {Roles} from '../services/auth/roles';

@Pipe({
    name: 'hasRole'
})
export class HasRolePipe implements PipeTransform {

    transform(value: Roles | Roles[], obj?: object): unknown {
        if (typeof value === 'object') {
            return AuthorisationService.hasAnyRole(value);
        } else {
            return AuthorisationService.hasRole(value);
        }
    }
}
